const _context: {
  accessToken: string | undefined | null
} = {
  accessToken: undefined,
}

export function getAccessToken() {
  return _context.accessToken
}

export function setAccessToken(token: string | undefined | null) {
  _context.accessToken = token
}
